export default __webpack_public_path__ + "static/media/freezer-fit_de.f69c7d5e.jpg";